import {ChartData} from 'chart.js';

import {orangeColors} from '../../../../../../../layouts/theme/designSystem';
import {DreamEmployerQuestion} from '../../../types/DreamEmployerTypes';

export const graphSerializer = (data: DreamEmployerQuestion, label: string): ChartData<'bar'> => {
  const labels = Object.keys(data.agreementResults).map(() => '');

  return {
    labels,
    datasets: [
      {
        label,
        data: [
          data.agreementResults.low.totalAgreement * 100,
          data.agreementResults.mid.totalAgreement * 100,
          data.agreementResults.high.totalAgreement * 100,
        ],
        backgroundColor: orangeColors[100],
      },
    ],
  };
};
